/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const FaceBook = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M3.251 0A3.26 3.26 0 0 0 0 3.251v19.508a3.261 3.261 0 0 0 3.251 3.252h9.866v-9.326h-3.114v-4.063h3.114v-2.036c0-3.138 2.318-5.596 5.275-5.596h2.871v4.588h-2.568c-.672 0-.87.387-.87.92v2.124h3.438v4.063h-3.438v9.326h4.934a3.262 3.262 0 0 0 3.252-3.252V3.251A3.26 3.26 0 0 0 22.759 0z" />
      </g>
    </svg>
  </span>
);

FaceBook.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

FaceBook.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default FaceBook;
